<template>
    <div>
        <DataTable ref="failureTable" :value="confirmedOutages" :lazy="true"
                   :loading="loading" class=""
                   :responsiveLayout="isMobile() ? 'stack' : 'scroll'" style="padding-bottom: 50px;"
        >
            <Column header="Obszar potwierdzonej awarii"
                    :style="isMobile() ? 'max-width: 1000px;' : 'min-width: 400px; max-width: 1000px;'"
                    field="addressList">
                <template #body="slotProps">
                    <div v-html="computedAddresses(slotProps.data.addressList)">
                    </div>
                </template>
            </Column>
            <Column header="Przybliżony czas naprawy" field="repairTime"
                    :style="isMobile() ? 'width: 80%' : ''" />
            <template #loading>
                Ładowanie potwierdzonych awarii. Proszę czekać.
            </template>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
    import {isMobile} from "@tenrok/vue3-device-detect";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import {TimeUtils} from "@/utils/TimeUtils";
    import {
        getCallNetFailuresLV,
        getCallNetFailuresHV,
    } from "@/swagger/vue-api-client";

    export default {
        name: "FailureTable",

        data() {
            return {
                loading: false,
                confirmedOutages: [],
            };
        },

        mounted() {
            this.onPage();
            document.querySelectorAll("table thead tr th").forEach((th) => {
                th.setAttribute("scope", "col");
            });
        },

        methods: {
            isMobile() {
                return isMobile;
            },

            async onPage() {
                this.loading = true;

                await getCallNetFailuresLV({
                    body: {searchCriteria: {includedDate: TimeUtils.adjustTimezone(new Date())}},
                })
                    .then((response) => {
                        response.data.items.forEach((item) => {
                            if (item.type === "FAILURE") {
                                this.confirmedOutages.push(item);
                            }
                        });
                    });
                await getCallNetFailuresHV({
                    body: {includedDate: TimeUtils.adjustTimezone(new Date()), status: "ACTIVE"},
                })
                    .then((response) => {
                        response.data.items.forEach((item) => {
                            if (item.type === "FAILURE") {
                                this.confirmedOutages.push(item);
                            }
                        });
                    });

                this.loading = false;
            },

            computedAddresses(addressList) {
                const addressMap = {};

                for (let i = 0; i < addressList.length; i += 1) {
                    const {streetType, streetName, residenceNumber} = addressList[i];
                    const key = ((streetType ? (streetType + " ") : "") + streetName).trim();

                    if (!addressMap[key]) {
                        addressMap[key] = [];
                    }

                    addressMap[key].push(residenceNumber);
                }

                const addressArr = Object.entries(addressMap).map(([key, numbers]) => key + " " + numbers.join(", "));

                return addressArr.join("<br>");
            },
        },

        components: {
            Column,
            DataTable,
        },
    };
</script>

<style lang="less">
@import "../../../components/assets/less/datatable.less";
@import "../../assets/less/eon-table.less";
@import "../../../assets/theme/variable.less";
</style>
